module.exports = __webpack_public_path__ + "static/media/sequelize.43c9d125.svg";